var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluetoothOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275",
    transform: "translate(-284 1618)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 72,
    height: 72,
    transform: "translate(284 -1618)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Intersection_4",
    "data-name": "Intersection 4",
    transform: "translate(280.846 -1628.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M48.629,76.01a6.46,6.46,0,0,1-6.46,6.46H10.46A6.46,6.46,0,0,1,4,76.01V16.93a6.46,6.46,0,0,1,6.46-6.46H42.169a6.46,6.46,0,0,1,6.46,6.46Zm-2.041-59.79a4.21,4.21,0,0,0-4.21-4.21H10.269a4.21,4.21,0,0,0-4.21,4.21V76.447a4.21,4.21,0,0,0,4.21,4.21H42.378a4.21,4.21,0,0,0,4.21-4.21Z",
    transform: "translate(0 0)",
    fill: "#08080b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M46.788,76.6a4.21,4.21,0,0,1-4.21,4.21H10.47A4.21,4.21,0,0,1,6.26,76.6V16.37a4.21,4.21,0,0,1,4.21-4.21H42.579a4.21,4.21,0,0,1,4.21,4.21ZM16.638,14.474a9.353,9.353,0,0,0-6.433.674,2.579,2.579,0,0,0-1.449,2.314V74.884a3.872,3.872,0,0,0,3.872,3.872H40.392a3.9,3.9,0,0,0,3.9-3.891V18.957c0-4.72-4.3-5.6-8.009-4.292a.679.679,0,0,0-.446.565c-.31,2.916-2.032,3.608-4.838,3.617-3.617.009-13.613,1.731-13.777-3.654a.765.765,0,0,0-.583-.72Z",
    transform: "translate(-0.201 -0.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M16.882,14.665a.765.765,0,0,1,.583.72c.164,5.385,10.159,3.663,13.777,3.654,2.806-.009,4.528-.7,4.838-3.617a.679.679,0,0,1,.446-.565c3.708-1.312,8.009-.428,8.009,4.292V75.057a3.9,3.9,0,0,1-3.9,3.891H12.872A3.872,3.872,0,0,1,9,75.075V17.654a2.579,2.579,0,0,1,1.449-2.314A9.353,9.353,0,0,1,16.882,14.665Zm19.371,4.519c-2.4,2.351-10.15,1.745-15.189,1.221s-4.3-.984-4.966-3.317a.8.8,0,0,0-.519-.556c-3.38-1.257-5,.182-5,3.663q.018,27.171.027,54.679A2.023,2.023,0,0,0,12.626,76.9h28.72A1.458,1.458,0,0,0,42.8,75.449q.273-28.246.064-56.8c-.027-2.97-4.629-3.216-5.658-1.257Q36.28,19.148,36.253,19.184Z",
    transform: "translate(-0.444 -0.341)",
    fill: "#08080b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M21.217,20.579c2.943-.128,12.793,1.13,15.189-1.221q.027-.036.957-1.795c1.03-1.959,5.631-1.713,5.658,1.257q.21,28.556-.064,56.8A1.458,1.458,0,0,1,41.5,77.071H12.78a2.023,2.023,0,0,1-2.023-2.023q-.009-27.508-.027-54.679c0-3.481,1.622-4.92,5-3.663a.8.8,0,0,1,.519.556Q17.245,20.761,21.217,20.579Zm2.87,31.508a.264.264,0,0,1,.474.164l.328,16.456a.7.7,0,0,0,1.2.465l9.868-10.4a.556.556,0,0,0,0-.765L27.7,49.426a.838.838,0,0,1,0-1.166l8.255-8.61a.48.48,0,0,0-.009-.756l-9.385-9.686a.966.966,0,0,0-1.658.665L24.8,45.025a.519.519,0,0,1-.9.355l-6.588-6.9a.82.82,0,0,0-1.349.893c1.185,2.724,6,6.7,8.155,9.121a.448.448,0,0,1-.009.665l-8.018,8.647a.887.887,0,0,0,.784,1.513.815.815,0,0,0,.383-.191A49.6,49.6,0,0,0,24.088,52.087Z",
    transform: "translate(-0.598 -0.514)",
    fill: "#f2e153"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M70.988,30.763c-.6-.538-1.859-1.066-2-2.169a.6.6,0,0,1,.966-.547c12.811,9.932,13.822,26.387.6,36.856a3.016,3.016,0,0,1-1.6.711.51.51,0,0,1-.374-.893c6.506-5.713,10.97-11.718,9.695-20.8A21.181,21.181,0,0,0,70.988,30.763Z",
    transform: "translate(-5.722 -1.55)",
    fill: "#cac9ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M24.586,53.321a49.6,49.6,0,0,1-6.834,7.043.815.815,0,0,1-.383.191.9.9,0,0,1-.784-1.513L24.6,50.4a.448.448,0,0,0,.009-.665c-2.159-2.424-6.97-6.4-8.155-9.121a.82.82,0,0,1,1.349-.893l6.588,6.9a.519.519,0,0,0,.9-.355l.109-15.153a.966.966,0,0,1,1.658-.665l9.385,9.686a.48.48,0,0,1,.009.756L28.2,49.494a.838.838,0,0,0,0,1.166l8.255,8.583a.556.556,0,0,1,0,.765l-9.868,10.4a.7.7,0,0,1-1.2-.465L25.06,53.485a.264.264,0,0,0-.474-.164Zm3.38-19.244a.3.3,0,0,0-.519.21L27.4,46.87a.3.3,0,0,0,.519.21L33.889,40.8a.3.3,0,0,0,0-.41Zm.009,19.1a.31.31,0,0,0-.538.21l-.046,12.6a.31.31,0,0,0,.538.21l5.831-6.278a.31.31,0,0,0,0-.419Z",
    transform: "translate(-1.096 -1.748)",
    fill: "#202327"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M65.261,35.065c8.519,7.5,8.173,19.262-1.02,25.74a1.247,1.247,0,0,1-1.531.146.711.711,0,0,1-.027-1.148c7.918-6.114,9.759-14.642,2.888-22.433-.847-.957-2.323-1.677-3.262-2.788a.483.483,0,0,1,.419-.793A4.563,4.563,0,0,1,65.261,35.065Z",
    transform: "translate(-5.17 -2.071)",
    fill: "#807f82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M29.045,34.451l5.923,6.314a.3.3,0,0,1,0,.41L29,47.453a.3.3,0,0,1-.519-.21l.046-12.583a.3.3,0,0,1,.519-.21Z",
    transform: "translate(-2.175 -2.122)",
    fill: "#f2e153"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M56.651,39.664c2.305-1.257,5.786,4.993,6.141,6.506.957,4.109-1.667,8.3-5.257,10.223a.765.765,0,0,1-.911-1.212c1.267-1.3,2.925-2.269,3.626-3.954q2.661-6.369-3.636-10.241a.765.765,0,0,1,.036-1.321Z",
    transform: "translate(-4.642 -2.579)",
    fill: "#08080b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M29.053,55.41l5.786,6.323a.31.31,0,0,1,0,.419l-5.831,6.278a.31.31,0,0,1-.538-.21l.046-12.6a.31.31,0,0,1,.538-.21Z",
    transform: "translate(-2.174 -3.984)",
    fill: "#f2e153"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetoothOnly);
export default __webpack_public_path__ + "static/media/bluetooth-only.63f31b2eac69d3c76cdbb9e19578fa48.svg";
export { ForwardRef as ReactComponent };